import { Box, Grow } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import { ReactElement, RefObject } from 'react';

import { popperSx } from './Popover.style';

interface Props {
  isOpen: boolean;
  close: () => void;
  anchorRef: RefObject<HTMLDivElement | null>;
  children: ReactElement;
}

export const Popover = ({ isOpen, close, anchorRef, children }: Props) => {
  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    // Dialogs, select menus and autocomplete lists opened from the popover are rendered in portals,
    // keep the popover (and the dialog it owns) open while the user interacts with them.
    // A select opens its menu on mousedown, so the click is reported on <body>: checking the
    // target is not enough, any open modal means the click belongs to it
    if (
      document.querySelector('.MuiModal-root:not(.MuiModal-hidden)') ||
      (event.target as HTMLElement).closest?.('.MuiAutocomplete-popper')
    ) {
      return;
    }

    close();
  };

  return (
    <Popper
      sx={popperSx}
      open={isOpen}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      placement="bottom-end"
      modifiers={[
        { name: 'flip', enabled: false },
        { name: 'preventOverflow', enabled: false },
      ]}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
          <Box>
            <ClickAwayListener onClickAway={handleClose}>{children}</ClickAwayListener>
          </Box>
        </Grow>
      )}
    </Popper>
  );
};
